import { render, staticRenderFns } from "./defaultTextualSection.vue?vue&type=template&id=78f4c410&scoped=true"
import script from "./defaultTextualSection.vue?vue&type=script&lang=ts"
export * from "./defaultTextualSection.vue?vue&type=script&lang=ts"
import style0 from "./defaultTextualSection.vue?vue&type=style&index=0&id=78f4c410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4c410",
  null
  
)

export default component.exports